import type { SVGProps } from "react";

/**
 * sync-lipsync
 * @category Social Media & Brands
 */
export default function IconSyncLipsync(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 32 32' fill='none' aria-hidden {...props}>
      <path
        fill='currentColor'
        d='M24.365 19.8c.334.598.516 1.24.516 1.91 0 3.131-3.977 5.668-8.881 5.668v-3.825c3.855 0 7.137-1.562 8.365-3.752M7.621 15.992C8.838 18.2 12.13 19.786 16 19.786v3.767c-4.905 0-8.881-2.549-8.881-5.679 0-.661.177-1.294.502-1.882'
      />
      <path
        fill='currentColor'
        d='M24.378 16.01c.326.59.503 1.224.502 1.883 0 .671-.182 1.312-.516 1.908-.393-.702-.997-1.34-1.763-1.883.776-.548 1.385-1.195 1.777-1.907M16 16c2.62 0 4.976.766 6.601 1.918-1.625 1.153-3.98 1.868-6.601 1.868v-3.784c-2.627 0-4.985-.741-6.612-1.909 1.627-1.153 3.986-1.877 6.612-1.877z'
      />
      <path
        fill='currentColor'
        d='M16 8.449c4.904 0 8.88 2.548 8.881 5.678 0 .66-.177 1.295-.503 1.884-1.216-2.205-4.507-3.795-8.378-3.795zM7.634 12.203c.392.703.992 1.343 1.754 1.89-.77.547-1.375 1.19-1.767 1.899a3.9 3.9 0 0 1-.502-1.884c0-.67.182-1.31.515-1.905M16 8.449c-3.857 0-7.14 1.563-8.366 3.754a3.9 3.9 0 0 1-.515-1.912c0-3.13 3.976-5.668 8.88-5.668z'
      />
    </svg>
  );
}
